var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.advert && _vm.advert.length>0)?_c('div',{staticClass:"recommend-list"},_vm._l((_vm.advert),function(item){return _c('div',{key:item.id,staticClass:"recommend-list-item"},[_c('img',{attrs:{"src":item.image,"alt":""}})])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }